import { render, staticRenderFns } from "./Create-Adjustment.vue?vue&type=template&id=1054f2d4"
import script from "./Create-Adjustment.vue?vue&type=script&lang=js"
export * from "./Create-Adjustment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports